import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingBrokerSelfRequestFormBanner.css';
import { NBSP } from 'shared/constants/symbols';

interface INewbuildingBrokerSelfRequestFormBannerProps {
  buttonText?: string;
  buttonLoading: boolean;
  onClick: () => void;
}

export const NewbuildingBrokerSelfRequestFormBanner: React.FC<INewbuildingBrokerSelfRequestFormBannerProps> = ({
  buttonText = 'О сервисе',
  buttonLoading,
  onClick,
}) => {
  return (
    <section className={styles['container']} data-testid="NewbuildingBrokerSelfRequestFormBanner">
      <div className={styles['inner']}>
        <UIHeading1>
          Подберём и{NBSP}поможем купить квартиру в{NBSP}новостройке. Бесплатно!
        </UIHeading1>
        <div className={styles['description-wrapper']}>
          <UIText1>Найдём жильё под{NBSP}ваш запрос</UIText1>
        </div>
        <div>
          <Button loading={buttonLoading} onClick={onClick}>
            {buttonText}
          </Button>
        </div>
      </div>
    </section>
  );
};
